/// <reference path='../_references.ts'/>

module App.HeaderMessages {
	export class HeaderMessagesService {
		static $inject: string[] = ['$http', 'Constants'];
		constructor(
			protected $http: ng.IHttpService,
			protected Constants: IConstants
		) {}

		public markRead(id: number): ng.IHttpPromise<GlobalMessage> {
			return this.$http.post(this.Constants.apiUrl + 'globalmessage/' + id + '/read', {});
		}

		public getActiveMessages(): ng.IHttpPromise<GlobalMessage[]> {
			return this.$http.get(this.Constants.apiUrl + 'globalmessage/active');
		}
	}
}
